import { FX_RATES_CSV_URL } from "@/src/sb/constants/configs"
import Papa from "papaparse"
import { useEffect, useState } from "react"

type FxRate = {
  date: string
  cbn_usd: number
  cbn_usd_percent_change: number
  parallel_usd: number
  parallel_usd_percent_change: number
  parallel_pounds: number
  parallel_pounds_percent_change: number
  parallel_euro: number
  parallel_euro_percent_change: number
  nafem_usd: number
  nafem_usd_percent_change: number
  nafex_usd: number
  nafex_usd_percent_change: number
  nafem_turnover: number
  nafem_turnover_percent_change: number
  cbn_pounds: number
  cbn_pounds_percent_change: number
  cbn_euro: number
  cbn_euro_percent_change: number
}

const useFxRates = () => {
  const [loading, setLoading] = useState(true)
  const [fxRates, setFxRates] = useState<any>(undefined)
  const [error, setError] = useState<string | undefined>(undefined)

  useEffect(() => {
    setLoading(true)
    fetch(FX_RATES_CSV_URL)
      .then((res) => res.text())
      .then((csvText) => {
        Papa.parse<FxRate>(csvText, {
          header: true,
          complete: (results: any) => {
            setFxRates(results.data as FxRate[])
            setLoading(false)
          },
          error: (error: any) => {
            setError(`error: ${error.message}`)
            setLoading(false)
          }
        })
      })
      .catch((fetchError) => {
        setError(`error: ${fetchError.message}`)
        setLoading(false)
      })
  }, [])

  return { loading, fxRates, error }
}

export default useFxRates
